import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const isMobileDevice = (): boolean =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

// Inertia shares a fresh `csrfToken` on every response so that raw fetch()
// calls (which bypass Inertia's own request pipeline) always use a valid token
// even after client-side navigation, where the <meta csrf-token> tag is stale.
export const getCsrfToken = (): string => {
  const inertiaPage = document.querySelector('script[data-page]')?.textContent
  if (inertiaPage) {
    try {
      const csrfToken = (JSON.parse(inertiaPage) as { props?: { csrfToken?: string } }).props
        ?.csrfToken
      if (csrfToken) return csrfToken
    } catch {
      // fall through to meta tag
    }
  }
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''
}
